import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import { Icon } from '@wartek-id/icon'
import { Text } from '@wartek-id/text'

import { useRoles } from 'utils/hooks/useRoles'

import RoleAndRegionDetails from './RoleAndRegionDetails'
import UserDetails from './UserDetails'

interface DesktopNavbarProps {
  children?: React.ReactNode
}

export const DesktopNavbar = ({ children }: DesktopNavbarProps) => {
  const { isSuperAdminUser } = useRoles()

  return (
    <div className="sticky top-0 z-50">
      {isSuperAdminUser && (
        <div className="bg-primary p-2">
          <div className="flex justify-center gap-2">
            <Icon fontSize="sm" color="inverse">
              information
            </Icon>
            <Text variant="body-sm" color="inverse">
              Anda sedang masuk sebagai Super Admin dengan akses penuh ke
              seluruh sistem
            </Text>
          </div>
        </div>
      )}

      <nav
        data-testid="navbar"
        className="flex flex-row items-center justify-between bg-white px-12 py-3 shadow"
      >
        <div className="flex flex-row items-center">
          <Link href="/" aria-label="Logo" className="flex gap-3">
            <Image
              src="/images/logo-kemdikbud.png"
              alt="Kemdikbud"
              width={44}
              height={44}
            />
            <Image
              src="/images/logo-ruang-gtk.svg"
              alt="Ruang GTK"
              width={60}
              height={44}
            />
          </Link>
          <div className="ml-4">
            {children || <Text variant="heading-lg">SIM KSPSTK</Text>}
          </div>
        </div>

        <div className="flex flex-row gap-4">
          <RoleAndRegionDetails />

          <UserDetails />
        </div>
      </nav>
    </div>
  )
}
